import {createSlice} from '@reduxjs/toolkit'
import {getAccessToken} from "../helpers/accessTokenManager";

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        accessToken: getAccessToken()
    },
    reducers: {
        setAccessToken: (state, action) => {
            state.accessToken = action.payload;
            window.localStorage.setItem("accessToken", action.payload);
            let newPath = `/SignIn?redirect=${window.location.pathname.substring(1)}${encodeURIComponent(window.location.search)}`;
            window.location.href = newPath;
        }
    },
})

export const {
    setAccessToken
} = authSlice.actions

export default authSlice.reducer